import { Layout, Avatar, Typography, Space, Switch, Dropdown, Button, Tooltip } from "antd";
import { MenuOutlined, DownOutlined, ArrowLeftOutlined, LogoutOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";

const { Header } = Layout;

// Two-letter initials from a full name, e.g. "Dr. Hérent" -> "DH".
const initialsOf = (name = "") => {
  const parts = name.replace(/^Dr\.?\s*/i, "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const HeaderComponent = ({ onMenuClick, style }) => {
  const { isDarkMode, toggleTheme, user, userRole, logout } = useAppContext();
  const location = useLocation();
  const navigate = useNavigate();

  const isCaseViewerPage =
    location.pathname.startsWith("/cas/") || location.pathname === "/blank";

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const menu = {
    items: [{ key: "logout", label: "Déconnexion", icon: <LogoutOutlined /> }],
    onClick: ({ key }) => {
      if (key === "logout") handleLogout();
    },
  };

  const fullName = user?.full_name || "";

  return (
    <Header
      style={{
        backgroundColor: "var(--color-header-bg)",
        color: "var(--color-text)",
        borderBottom: `1px solid ${isDarkMode ? "#262626" : "#E5E7EB"}`,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 16px",
        ...style,
      }}
    >
      <Space size={8}>
        <MenuOutlined
          style={{ fontSize: "20px", cursor: "pointer", color: "var(--color-text)" }}
          onClick={onMenuClick}
        />
        {isCaseViewerPage && (
          <Tooltip title="Retour aux cas">
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/cas")}
            >
              Retour
            </Button>
          </Tooltip>
        )}
      </Space>

      <Space>
        <Switch
          checkedChildren="Dark"
          unCheckedChildren="Light"
          checked={isDarkMode}
          onChange={toggleTheme}
        />
        <Dropdown menu={menu} trigger={["click"]}>
          <Space align="center" style={{ cursor: "pointer" }}>
            <Avatar style={{ backgroundColor: "#87d068" }}>
              {initialsOf(fullName)}
            </Avatar>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
              <Typography.Text style={{ color: "var(--color-text)" }} strong>
                {fullName}
              </Typography.Text>
              <Typography.Text type="secondary" style={{ fontSize: "12px", lineHeight: 1 }}>
                {userRole}
              </Typography.Text>
            </div>
            <DownOutlined />
          </Space>
        </Dropdown>
      </Space>
    </Header>
  );
};

export default HeaderComponent;
